"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageHandlerProvider = exports.useHandleMessage = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _NotificationSystem = require("./NotificationSystem");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var MessageHandlerContext = /*#__PURE__*/_react["default"].createContext();
var MessageHandlerProvider = function MessageHandlerProvider(props) {
  var systemNotification = (0, _NotificationSystem.useNotificationSystem)();
  var _useState = (0, _react.useState)(1),
    messageId = _useState[0],
    setMessageId = _useState[1];
  var handleMessage = function handleMessage(message) {
    var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var defaultNotification = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var additionalHtml = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var forceErrorColors = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var forceBgColor = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : props.forceBgColor;
    setMessageId(messageId + 1);
    if (!isError) {
      systemNotification.show({
        id: messageId,
        timeout: 7000,
        content: function content(_ref) {
          var close = _ref.close;
          return __jsx(_Box["default"], {
            "data-test": "message-success",
            sx: {
              position: "relative"
            }
          }, __jsx(props.notificationComponent, {
            isError: forceErrorColors || isError,
            defaultNotification: defaultNotification,
            message: message,
            onClick: close,
            additionalHtml: additionalHtml,
            forceBgColor: forceBgColor
          }));
        },
        placement: props.errorsPlacement
      });
    } else {
      var finalMessage;
      if (!message.response) {
        return;
      }
      if (message.response.body.parameters === undefined) {
        if (message.hasOwnProperty("message")) {
          finalMessage = message.response.body.message;
        }
      } else {
        if (message.hasOwnProperty("message")) {
          if (Array.isArray(message.response.body.parameters)) {
            finalMessage = message.response.body.parameters.reduce(function (prev, current, index) {
              return prev.replace("%".concat(index + 1), current);
            }, message.response.body.message);
          } else if (typeof message.response.body.parameters === "object") {
            finalMessage = Object.entries(message.response.body.parameters).reduce(function (prev, current) {
              var _current = (0, _slicedToArray2["default"])(current, 2),
                key = _current[0],
                value = _current[1];
              return prev.replace("%" + key, value);
            }, message.response.body.message);
          }
        }
      }
      if (finalMessage !== undefined) {
        systemNotification.show({
          id: messageId,
          timeout: 7000,
          content: function content(_ref2) {
            var close = _ref2.close;
            return __jsx(_Box["default"], {
              sx: {
                position: "relative"
              }
            }, __jsx(props.notificationComponent, {
              isError: isError,
              defaultNotification: false,
              message: finalMessage,
              onClick: close
            }));
          },
          placement: props.errorsPlacement
        });
      }
    }
  };
  return __jsx(MessageHandlerContext.Provider, {
    value: {
      handleMessage: handleMessage
    }
  }, props.children);
};
exports.MessageHandlerProvider = MessageHandlerProvider;
var useHandleMessage = function useHandleMessage() {
  return (0, _react.useContext)(MessageHandlerContext);
};
exports.useHandleMessage = useHandleMessage;